import { render, staticRenderFns } from "./echartscom.vue?vue&type=template&id=6f1b567e&scoped=true&"
import script from "./echartscom.vue?vue&type=script&lang=js&"
export * from "./echartscom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1b567e",
  null
  
)

export default component.exports